module.exports = __webpack_public_path__ + "static/media/r382.dc6b6a30.jpg";